import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

export default function CustomInput({
  inputProps,
  label,
  value,
  onChange,
  parentClassName,
  password,
  disabled,
}) {
  const [viewPass, setViewPass] = useState(false);
  const showLabel = Boolean(label);

  const isShortWidth = value === "Sample Location" || value === "Lab Code";

  const inputStyle = {
    ...(isShortWidth ? { width: "96%" } : {}),
    ...(showLabel ? {} : { padding: "0 17px 0 20px" }),
  };

  return (
    <div className={`float-label ${parentClassName || ""}`}>
      {showLabel && (
        <label className={value ? "Active input-field" : "input-field"}>
          {label}
        </label>
      )}
      <input
        className="form-control"
        style={inputStyle}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...inputProps}
        {...(password ? { type: viewPass ? "text" : "password" } : {})}
      />
      {password && (
        <FontAwesomeIcon
          className="pass-eye"
          icon={viewPass ? faEyeSlash : faEye}
          onClick={() => setViewPass((s) => !s)}
        />
      )}
    </div>
  );
}
